var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWifiHome(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_11005_4236",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 48,
    height: 48
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_11005_4236)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.99997 38.0001V18.6426L5.83847 21.8426L4.92297 20.6346L24 6.03857L43.077 20.6461L42.1615 21.8426L37.9615 18.6426L24 7.98107L11.5385 17.4961V36.4616H22.396C22.437 36.7052 22.4653 36.9636 22.481 37.2366C22.4963 37.5096 22.5231 37.7641 22.5615 38.0001H9.99997ZM33.923 45.4616H27.154V43.6926H30.85C29.7526 42.7412 28.8623 41.6014 28.179 40.2731C27.4956 38.9451 27.154 37.5464 27.154 36.0771C27.154 33.9334 27.7905 32.0411 29.0635 30.4001C30.3365 28.7591 31.9563 27.6539 33.923 27.0846V28.9156C32.4563 29.4512 31.2563 30.3659 30.323 31.6596C29.3896 32.9532 28.923 34.4257 28.923 36.0771C28.923 37.3001 29.2198 38.4692 29.8135 39.5846C30.4071 40.6999 31.1873 41.6641 32.154 42.4771V38.6926H33.923V45.4616ZM38.231 45.0691V43.2001C39.731 42.6564 40.9393 41.7314 41.856 40.4251C42.7726 39.1187 43.231 37.6694 43.231 36.0771C43.231 34.8541 42.9341 33.6847 42.3405 32.5691C41.7468 31.4537 40.9666 30.4897 40 29.6771V33.4616H38.231V26.6926H45V28.4616H41.304C42.4013 29.4129 43.2916 30.5527 43.975 31.8811C44.6583 33.2091 45 34.6077 45 36.0771C45 38.2207 44.3635 40.1131 43.0905 41.7541C41.8175 43.3951 40.1976 44.5001 38.231 45.0691Z",
    fill: "#0395FF"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWifiHome);
export default __webpack_public_path__ + "static/media/wifi_home.d67649aa388333831b97201c1d03def3.svg";
export { ForwardRef as ReactComponent };